export default __webpack_public_path__ + "static/media/5.fd260519.jpg";